<template>
    <div
      class="board"
     
    >
    <div class="sks"><span @click="gos" style="color: #000;">
          ＜ </span>
          <div @click="gos"  class="timg" style="width: 30%;position: absolute; top: 0; left: 0.2rem; color: #000;">
            砍价专区

          </div>
          <div class="serch" style="width: 60%;position: absolute; top: 0rem;right: 0.2rem;">
            <van-search shape="round" background="#fff100" v-model="value" placeholder="请输入搜索关键词" />
          </div>
      </div>
     <img style="position: relative; z-index: 999;margin-top: 0.2rem;" src="../../../assets/you/1.png" alt="">
     <div class="guod">
      <div class="dian" >
       
      </div>
      <!-- <img src="../../assets/s11/ss/02-1.png" alt=""> -->
     </div>
     <div class="wai">
     <div class="nei" v-for="v in list" :key="v.ktime">
        <div class="content">
          <ul>
            <li
              class="clearfix"
              v-for="v1 in v.standardList"
              :key="v1.id"
              @click="goi(v1.commodity_id,v.begin_date,v1.goods_quantity,vip1)"
            
            >
            
            <div class="con">
              <img
                :src="v1.sku_thumb"
                alt=""
              >
              <p class="name">{{v1.goods_name}}</p>
              <!-- <p class="price">￥{{v.min_price}}</p> -->
              
              <div class="progress2"> 
                    <p class="num1" style="line-height: 0.4rem;">原价 <span style=" color: #989696;
      text-decoration: line-through;">￥{{v1.maxPrice}}</span> </p>
                    <p class="num2">可砍至 <span style="color: red;font-size: 0.4rem;">￥{{ v1.minPrice }}</span></p>
                </div>
             <div class="xu" style="border-bottom: 1px dashed #ddd;"></div>
             <div class="qu">
              <div class="yuan">
                <!-- ￥{{v1.maxPrice}} -->
              </div>
              <div class="yuan1">
                ￥{{v1.minPrice}}
              </div>
              <div class="dian" :style="'top:'+(v1.top)+'%;left:'+(v1.left)+'%;'" >
                
                <div class="" style="position: relative;left: -0.5rem; color: red;">￥{{v1.currentPrice}}</div>
                <img src="../../../assets/you/3.png" alt="">
              </div>
              <!-- <div class="xia" id="xia">
                当前价 <br>
                {{v1.currentPrice}}
              </div> -->
              <div class="shang">
                底价 <br>
                {{v1.maxPrice}}
              </div>
             </div>
            </div>
             <div class="but" style="position: absolute;left: 5rem;bottom: 0.2rem;">
              <img src="../../../assets/you/5.png" alt="">
             </div>
            </li>
           
          </ul>
        </div>
        

     </div>
     </div> 
      
    
    
      
     
      <div class="" style="height:0.5rem" ></div>
    <div class="dao" v-show="false">
      <van-count-down @finish='wanc' millisecond :time="time" format="HH:mm:ss:SS" />
    </div>
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import {search,progress, Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast ,CountDown, Tab, Tabs,Dialog } from 'vant'
  
  Vue.use(Swipe)
    .use(SwipeItem)
    .use(Lazyload, { lazyComponent: true })
    .use(NoticeBar)
    .use(Grid)
    .use(GridItem).use(search).use(Popup).use(Button).use(CountDown).use( Tab).use(Tabs ).use(Dialog).use(progress)
  
  export default {
    name: 'board',
    created () {
         if (JSON.parse(localStorage.getItem('user')).id != 0) {
        this.login = 1
      } else {
      }
      if ([16, 17, 23].indexOf(this.$store.state.shopid) == -1) {
        this.jf = true
      } else {
        this.jf = false
      }
     // 'John'
          console.log(this.$route.query.pushts)
      if (this.$route.query.pushts) {
        this.$store.state.shopid=this.$store.state.shopid? this.$store.state.shopid:this.$route.query.pushts
     }
      this.axios.post('userInfo', { store_id: this.$store.state.shopid, }).then(res => {               
            localStorage.setItem('vip', JSON.stringify({ id: res.data.info.super_vip }))
            localStorage.setItem('user-level', JSON.stringify({ id: res.data.info.level }))
           this.vip=res.data.info.super_vip
        }).catch(ref => { })
      this.vip1 = JSON.parse(localStorage.getItem('vip')).id
      
      this.xtime=new Date().getHours()
      this.axios
          .get('marketingList', {
            params: {
              // this.$store.state.shopid
              store_id: this.$store.state.shopid,
            },
          }).then(res => {
            console.log(res)

            // console.log(new Date())
            res.data.data.forEach(v => {
              v.time= Date.parse(v.end_date)-(Date.parse(new Date()))
            })
            res.data.data.forEach(v1 => {
              if (v1.time > 0 && v1.status == 1) {
                v1.standardList.forEach(v2 => {
                  // v2.maxPrice=100
                  // v2.minPrice = 0
                  // v2.currentPrice = 51
           let a = (v2.maxPrice - v2.currentPrice) / (v2.maxPrice - v2.minPrice)
           console.log(a)
           if (a == 0) {
             v2.top=0-10
           v2.left = 10
           } else if (a == 1) {
             v2.top=28
             v2.left = 75
           } else if(a >= 0.5) {
            console.log(a)
             v2.top = (50*a)-30
             v2.left = 65*a
           } else {
            v2.top = (38*a)-20
             v2.left = 65*a
           }
           
         })
                this.list.push(v1)
              }
             

             
                // this.list.push(v1)
              
            });
            console.log(this.list)
            // this.list=res.data.data
            // this.cl()
          }).catch(ref=>{})
            
    },
    data () {
      return {
        value: '',
        show: false,
        images: [1, 2],
        searchBarFixed: false,
        navSwitch: 1,
        number: -1,
        str: '',
        ad: [],
        list:[],
        classList: [{id:'1',stime:'14',time:'1702310400000',etime:'18',name:'sda1'},{stime:'14',time:'1702396800000',etime:'16',id:'2',name:'sda2'},{id:'3',stime:'16',time:'1702310400000',etime:'18',name:'sda3'},],
        classList1: [],
        screenType: 'zonghe',
        productList: [],
        isEnd1: true,
        deswiper: '',
        login: sessionStorage.getItem('login'),
        isEnd: false, //判断是否为最后一页
        params: {
          page: 1,
          id: '',
          sort_field: 'sort',
          class_three: '',
          sort_type: '',
        },
        screenState: 1,
        totalHeight: 0,
        vip1:0,
        statusNav: 1,
        id: 157,
        fg:false,
        time:0,
        active:0,
        gs:0,
        xtime:0
      }
    },
    props: {
    },
    computed: {
  
    },
    watch: {
  
    },
   
    mounted () {
  
    },
    methods: {
      gos () {
        this.$router.push("/")
      },
     
      getClientHeight () {
  
      },
     goi(id,s,num,vip){
        
    //       if(this.vip1==0){
    //             Dialog.confirm({   title: '',
    //  message: '此活动只限鲸会员用户购买',
    //  confirmButtonText : '开通鲸会员',
    // confirmButtonColor:'red', })
    // .then(() => {
    //   this.$router.push('opvip2')
    //  })
    // .catch(() => {
    //   // on cancel
    //  })
    //         return
    //       }
       
         
  if(num<=0){
    Toast('此商品以抢完')
    return false
  }
       
        
  this.$router.push({ name: 'chuxp', query: { id ,jian:1} })
  
        
  
      },
      cl1(){
        Toast('商品正在筹备中~')
      },
  cl(){
    let arr=[]
    let arr1=[]
    let list1=[]
    this.list.forEach(v=>{   
        if(arr.indexOf(v.start_date_h)==-1){
          arr.push(v.start_date_h)       
            arr1.push({etime:v.end_date_h, ktime:v.start_date_h,txt:new Date().getHours()>= Number(v.start_date_h) ?'正开抢':'即将开抢'})
        } 
       
    })
      arr1.forEach(v1=>{
        list1=[]
        this.list.forEach(v2=>{
          if(v1.ktime==v2.start_date_h){
            if(new Date()>v2.start_date_ll*1000 ){
            list1.push(v2)
            }
          }
        })
        v1.list=list1
      }
    )
   
    // let arr2=[]
    arr1.forEach((v,i)=>{
      if(v.ktime<=this.xtime){
        if(this.xtime<v.etime){
        this.active=i
  
        }else{
        this.active=0
  
        }
      }else{
  
        // arr2.push(v)
      }
    })
    arr1.forEach(v => {
      v.list.sort(function(a,b){
        return a.sort-b.sort
      })
    })
    this.classList1=arr1
    // console.log(arr)
  },
  
      enterDetail (goods) {
        return false
        this.$router.push({
          name: 'product',
          params: {
            id: goods.id,
            status: 1,
          },
        })
      },
      
     toList(){
  
     },
      getProductList () {
  
      },
      getClassList () {
  
      },
      wanc(){
        this.fg = false
          
      }
    },
  
    destroyed () { },
    updated () { },
    components: {},
  }
  </script>
  
  
  <style lang="less" scoped>
  .w1{
    // width: 80%;
    margin: 0 auto;
    padding-top: 0.4rem;
    // background-color: #ff3301;
  
  }
  .w2{
    padding:  0.2rem;
  }
  .mi {
    padding: 0.5rem;
    text-align: center;
  
    p {
      font-size: 0.5rem;
      margin: 0.5rem;
    }
    input {
      height: 1rem;
      width: 70%;
      border-radius: 5%;
      font-size: 0.4rem;
    }
    margin-bottom: 1rem;
  }
  .sks {
    width: 100%;
    z-index: 99;
    height: 1.5rem;
    // background-color: #ff3301;
    text-align: center;
    // padding-left: 1rem;
    font-weight: 600;
    font-size: 0.4rem;
    line-height: 1.2rem;
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;
    //   margin-top: 0.5rem;
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%;
    background-color: #fff100;
    span {
      width: 1rem;
      position: absolute;
      left: 0;
      font-size: 0.5rem;
    }
  }
  .sp {
    width: 100%;
    height: 5.4rem;
    overflow: hidden;
  }
  .sp::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .pad {
  //   height: 0.2rem;
  // position: relative;
  // bottom: 0.2rem;
  padding: 0.4rem 0.2rem 0 0.2rem;
  
  //   background-color: #ff1d1e;
  }
  
  
  
  .wgdb {
  
  padding: 0 0.2rem;
    // position: relative;
    // bottom: 1.8rem;
    .ws{
    z-index: 2;
  // border: 1px solid #f7f4ad;
  border-radius: 0.1rem;
      padding-top:0.5rem;
      // background-color: #fff;
      
      .wsn{
          float: left;
          width: 50%;
          padding: 1%;
          img{
              width: 100%;
          }
      }
    }
    .wgdb1{
      padding: 0.5rem 0.2rem;
      //  background-color: rgba(79, 77, 77, 0.324);
  padding-top: 1rem;
      }
      .more{
        text-align: center;
        font-size: 0.54rem;
        color: white;
        line-height: 2rem;
      }
  }
  
  
  
  .hot{
      //  position: relative;
          padding: 0.2rem;
  background-color: #fbf6fd;
          // bottom: 1rem;
          .sd{
              height: 0.2rem;
          }
      .top{
          // width: 30%;
          height: 1rem;
          img{
              width: 1.5rem;
              float: left;
          }
          p{
              color: #fff;
              font-size: 0.5rem;
              line-height: 0.6rem;
              padding-left: 1.7rem;
          }
      }
  }
  
  .dao{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      z-index: 99;
  }
  .guod{
    position: relative;
    .dian{
      width: 100%;
      height: 0.2rem;
      // background-color: #ffa082;
      border-radius: 30% 30% 0 0;
      position: relative;
      bottom: 0.5rem ;
        // padding-top: 0.8rem;
  padding: 0.2rem 0.2rem;
      .dnei{
        background-color: #fff;
        border-radius: 0.3rem;
        height: 0.5rem;
        padding: 0.4rem 0rem 0rem 0.4rem;
        li{
          float: left;
          // margin: 0.1rem;p
          margin-right: 0.05rem;
          width: 24%;
          text-align: center;
          color: #5d5a5a;
          .p1{
            padding: 0.1rem;
            background-color: red;
            border-radius: 0.4rem;
            color: #fff;
  
          }
        }
      }
    }
  }
  .board {
    padding-top:1.1rem;
    // 轮播
    overflow-x: hidden;
    //   padding-top: 0.8rem;
    background-color: #fff100;
    height: 100%;
    .mint-swipe {
      width: 100%;
      height: 3.28rem;
  
      .mint-swipe-items-wrap {
        width: 100%;
        height: 3.28rem;
  
        .mint-swipe-item {
          width: 100%;
          height: 3.28rem;
  
          .board-banner-img {
            width: 100%;
            height: 3.28rem;
            background-size: 100%;
          }
        }
      }
    }
    .flp {
      // background-color: #f8a4a4;
      padding: 0 0.2rem;
      padding-top: 0.2rem;
      position: relative;
      // bottom: 2rem;
        
    }
    .fenl {
      background: url(../../../assets/s11/ss/05.png) no-repeat center;
     background-size: 100% 100%;
      // margin: 0 0.2rem;
      p {
        height: 0.75rem;
        line-height: 0.5rem;
        font-weight: 700;
        font-size: 0.3rem;
      }
      // background: #fff;
      padding: 0 0.3rem;
      padding-top: 1.2rem;
      text-align: center;
      box-sizing: border-box;
  
      .fenl_1 {
        width: 16.5%;
        text-align: center;
        float: left;
        margin-bottom: 0.45rem;
  
        img {
          width: 1.2rem;
          // height: 1.5rem;
          border-radius: 5px;
          margin: 0 auto;
        }
  
        div {
          color: #333;
          font-size: 0.22rem;
          margin-top: 0.12rem;
        }
      }
    }
  .sz{
      // display: flex;
      position: relative;
      // bottom: 1.5rem;
  padding: 0 0.2rem;
  padding-top: 1rem;
  z-index: 22;
      .szn{
          float: left;
          width: 33.3%;
          margin: 0 auto;
         
      }
  }
    .mt {
      margin-top: 10px;
    }
  
    .scrolltop {
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 1000;
      margin-top: 0;
    }
  
    .board_imglist {
      background: #fff;
      margin-top: 1px;
      padding: 0.21rem;
      padding-top: 0.26rem;
      padding-bottom: 0.45rem;
  
      .board_img:nth-child(odd) {
        float: left;
        width: 48.5%;
      }
  
      .board_img:nth-child(even) {
        float: right;
        width: 48.5%;
      }
  
      .board_img {
        height: 5rem;
  
        .title {
          height: 0.6rem;
        }
  
        div:first-child {
          img {
            width: 100%;
            height: 3.2rem;
          }
        }
  
        div:nth-child(2) {
          margin-top: 0.16rem;
  
          span.sp1 {
            color: #a22d2b;
            font-size: 0.26rem;
            border: 1px solid #a22d2b;
            padding: 0.02rem 0.05rem;
            border-radius: 0.05rem;
          }
  
          span.sp2 {
            color: #333;
            font-size: 0.26rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 100%;
          }
        }
  
        div:last-child {
          margin-top: 0.16rem;
  
          span:first-child {
            color: #a22d2b;
            font-size: 0.26rem;
          }
  
          /*span:last-child {*/
          /*line-height: 0.2rem;*/
          /*color: #999;*/
          /*font-size: .26rem;*/
          /*text-decoration: line-through*/
          /*}*/
        }
      }
    }
  }
  .wai{
      padding: 0.2rem;
        position: relative;
      bottom: 0.5rem ;
      // background-color: #ffa082;
      
  }
  .nei{
      // padding: 0.2rem 0;
      background-color: #fff100;
      // margin-bottom: 0.1rem;
      border-radius: 0.3rem;
      overflow: hidden;
       .pt1{
          font-size: 0.43rem;
      }
      .pt2{
          font-size: 0.3rem;
      }
      .jsl{
        text-align: center;
        // line-height: 1.5rem;
        padding-top: 0.2rem;
        color: #474646;
        font-size: 0.45rem;
      }
  }
  .content {
      flex: 1;
      background-color: #fff100;
      .title {
        text-align: center;
        font-size: 0.4rem;
        height: 1rem;
      }
      ul {
        li {
          // float: left;
          // width: 45%;
          padding: 0.4rem 0.2rem ;
          // padding-left: 0.1rem;
          // padding-right: 0.1rem;
          // margin-left: 0.1rem;
         background-color: #fff;
         margin-bottom: 0.2rem;
         border-radius: 0.2rem;
         position: relative;
          text-align: center;
          .con{
          // background-color: rgb(238, 236, 236);
          height: 3.2rem;
  
          }
          img {
            width: 3.2rem;
            float: left;
            margin-right: 0.2rem;
          }
          .price {
            height: 0.9rem;
            line-height: 0.9rem;
            font-size: 0.4rem;
            color: #a22d2b;
          }
          .name {
            font-size: 0.373333rem;
              padding-top: 0rem;
          font-weight: 600;
            color: #333;
            display: -webkit-box;
    -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
  
          }
          .progress{
              // overflow: hidden;
              padding-top: 0.2rem;
             margin-left: 3.5rem;
              width: 35%;
          .progress1{
            display: flex;
            justify-content: space-between;

            }
           padding-bottom: 0.2rem;
          }
          .progress2{
            display: flex;
            padding-top: 0.2rem;
            line-height: 0.5rem;
            width: 56%;
            justify-content: center;
            }
         
              .num1{
                padding-right: 0.2rem;
                // padding-bottom: 0.2rem;
              }
              // line-height: -2rem;
        
          .qu{
              width: 5.8rem;
              height: 1.85rem;
             margin-left: 3.25rem;
                  margin-top: 0.25rem;
      // text-align: center;
  padding-left: 0.5rem;
 position: relative;

        background: url(../../../assets/you/2.png) no-repeat center;
     background-size: 100% 100%;
     .yuan{
      color: #989696;
      text-decoration: line-through;
      // position: absolute;
      // top: -0.15rem;
      // left: 0.05rem;
     }
     .yuan1{
      color: red;
      // text-decoration: line-through;
      position: absolute;
      bottom: 0.25rem;
      right:  -0.25rem;
     }
     .dian{
      position: absolute;
      top: 10%;
      left: 6%;
      width: 0.4rem;
      img{
        width: 100%;
      }
     }
     .xia{
      position: absolute;
      top: 28%;
      left: 0%;
      width: 1.75rem;
      height: 1.2rem;
      background: url(../../../assets/you/6.png) no-repeat center;
      background-size: 100% 100%;
  font-size: 0.25rem;
  color: #fff;
  // line-height: 1.5rem;
  padding-top: 0.2rem;
     }
     .shang{
      position: absolute;
      top: -15%;
      right: -5%;
      width: 1.2rem;
      height: 1.52rem;
      background: url(../../../assets/you/4.png) no-repeat center;
      background-size: 100% 100%;
  font-size: 0.25rem;
  color: #fff;
  // line-height: 1.5rem;
  padding-top: 0.3rem;
     }
          }
          .name2 {
            font-size: 0.373333rem;
            color: #333;
           padding: 0.1rem;
           padding-top: 0.2rem;
          }
           .name3 {
            font-size: 0.373333rem;
            color: rgb(241, 49, 49);
           padding: 0.1rem;
          //  padding-top: 0.2rem;
          }
        }
      }
    }
    .dy{
      // background-color: #f6f6f6;
      // height: 1rem;
      position: relative;
      bottom: 0.5rem;
      border-radius: 0 0 50% 50%;
    }
    .tianjia{
      padding-top: 0.5rem;
      height: 3.5rem;
      background-color: #f6f6f6;
      text-align: center;
  
      img{
        width: 80%;
        height: 2.8rem;
        margin: 0 auto;
      }
    }
    .tianjia1{
      background-color: #f6f6f6;
  
    }
  </style>
  